import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <TopicsSection />
        <CardsSection />
        <CommentsSection />
        <UpdatesSection />
        <RankingSection />
        <FaqSection />
        <ContactSection />
        <AppSection />
        <AboutSection />
        <MediaSection />
        <FeaturesSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}